// extracted by mini-css-extract-plugin
export default {"EditorWrap":"base-editor_EditorWrap__GHiHa","Editor":"base-editor_Editor__bknD9"};